export default "__VITE_ASSET__pzx3nI8N__"